module.exports = __webpack_public_path__ + "media/applicants/shopper1-9772cec3.jpg";